import { IconButton, InputAdornment } from '@mui/material'
import Lock from '@mui/icons-material/Lock'
import LockOpen from '@mui/icons-material/LockOpen'
import { TextField } from '@carsys/ui'
import React from 'react'
import { isInvalid } from './utils'

interface ILockableInput {
  params: { [key: string]: any }
  props: { [key: string]: any }
}

const LockableInput: React.FC<ILockableInput> = ({ params, props }) => {
  const { initialValue = true, required, multiple, input, meta, helperText, changeHandler, ...rest } = props
  const [locked, setLocked] = React.useState<boolean>(initialValue)

  const handleClick = () => {
    setLocked(previousValue => !previousValue)
    if (changeHandler) {
      changeHandler(!locked)
    }
  }

  const requiredValidation = multiple && required ? input.value?.length === 0 : !!required

  return (
    <TextField
      {...params}
      required={requiredValidation}
      error={isInvalid(meta)}
      helperText={isInvalid(meta) ? meta.error : props.helperText}
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <InputAdornment position='start' style={{ position: 'absolute', right: 0 }}>
            <IconButton size='small' onClick={handleClick} data-testid='input-lock-toggle'>
              {locked ? <Lock /> : <LockOpen />}
            </IconButton>
          </InputAdornment>
        ),
        style: { paddingRight: 30 }
      }}
      {...rest}
      disabled={locked}
    />
  )
}

export default LockableInput
